import * as Sentry from '@sentry/react';
import { Navigation } from '@bo-components/navigation/Navigation';
import { Sidebar } from '@bo-components/navigation/Sidebar';

export interface LandingPageProps {
  children: React.ReactNode;
}

export const LandingPage = ({ children }: LandingPageProps) => {
  return (
    <>
      <Sidebar>
        <Navigation />
      </Sidebar>
      <main className="bg-soFresh-100 h-full overflow-scroll lg:ml-52">
        <Sentry.ErrorBoundary
          fallback={
            <h1 className="text-soClean-100 m-auto h-16 w-96 justify-center py-16 text-xl font-bold">
              UnExpected Error: Alert DEV Team
            </h1>
          }
        >
          {children}
        </Sentry.ErrorBoundary>
      </main>
    </>
  );
};
